import { useState } from 'react';
import { faqItems } from '../../../mocks/faq';

export default function CourseFAQSection() {
  const [openId, setOpenId] = useState<number | null>(null);

  const toggle = (id: number) => {
    setOpenId(openId === id ? null : id);
  };

  return (
    <section className="py-24 bg-white">
      <div className="max-w-4xl mx-auto px-6 lg:px-8">

        {/* Header */}
        <div className="text-center mb-14">
          <span className="inline-block px-4 py-2 border-2 border-orange-400 text-orange-500 text-sm font-semibold rounded-full mb-6 uppercase tracking-wide">
            Ainda tem dúvidas?
          </span>
          <h2 className="text-4xl lg:text-5xl font-bold text-gray-900 leading-tight mb-4">
            Perguntas frequentes
          </h2>
          <p className="text-lg text-gray-500 max-w-2xl mx-auto">
            Respondemos tudo o que você precisa saber antes de se inscrever
          </p>
        </div>

        {/* Accordion */}
        <div className="space-y-3 mb-14">
          {faqItems.map((item) => {
            const isOpen = openId === item.id;
            return (
              <div
                key={item.id}
                className={`rounded-2xl border transition-all duration-300 ${
                  isOpen
                    ? 'border-orange-200 bg-orange-50/40'
                    : 'border-gray-100 bg-gray-50/60 hover:border-orange-100'
                }`}
              >
                <button
                  onClick={() => toggle(item.id)}
                  className="w-full flex items-center justify-between gap-4 px-6 py-5 text-left cursor-pointer"
                >
                  <span
                    className={`text-base font-semibold transition-colors duration-300 ${
                      isOpen ? 'text-gray-900' : 'text-gray-700'
                    }`}
                  >
                    {item.question}
                  </span>
                  <div
                    className={`w-8 h-8 flex items-center justify-center rounded-full flex-shrink-0 transition-all duration-300 ${
                      isOpen
                        ? 'bg-orange-500 text-white rotate-180'
                        : 'bg-gray-200 text-gray-500'
                    }`}
                  >
                    <i className="ri-arrow-down-s-line text-lg"></i>
                  </div>
                </button>

                <div
                  className={`overflow-hidden transition-all duration-300 ease-in-out ${
                    isOpen ? 'max-h-60 opacity-100' : 'max-h-0 opacity-0'
                  }`}
                >
                  <p className="px-6 pb-5 text-gray-600 leading-relaxed text-[15px]">
                    {item.answer}
                  </p>
                </div>
              </div>
            );
          })}
        </div>

        {/* CTA de suporte */}
        <div className="text-center bg-gradient-to-br from-orange-50 to-amber-50 rounded-2xl border border-orange-100 px-8 py-10">
          <div className="w-12 h-12 flex items-center justify-center bg-green-100 rounded-full mx-auto mb-4">
            <i className="ri-customer-service-2-line text-green-600 text-2xl w-6 h-6 flex items-center justify-center"></i>
          </div>
          <h3 className="text-lg font-bold text-gray-900 mb-2">
            Sua pergunta não está aqui?
          </h3>
          <p className="text-gray-500 text-sm mb-6 max-w-sm mx-auto">
            Nossa equipe responde em minutos pelo WhatsApp em dias úteis
          </p>
          <div className="flex justify-center">
            <a
              href="https://wa.me/"
              target="_blank"
              rel="nofollow noopener noreferrer"
              className="inline-flex items-center gap-2 px-6 py-3 bg-green-600 text-white font-semibold rounded-full hover:bg-green-700 transition-all duration-300 whitespace-nowrap cursor-pointer text-sm"
            >
              <i className="ri-whatsapp-line text-lg w-5 h-5 flex items-center justify-center"></i>
              Falar com a equipe no WhatsApp
            </a>
          </div>
        </div>

      </div>
    </section>
  );
}
